export default class HomeScreenState {

    constructor() {
        this.storylineSelectOpen = false;
    }

    get showStart() {
        return this.storylineSelectOpen === false;
    }

    get showStorylineSelect() {
        return this.storylineSelectOpen === true;
    }

    thumbnailUrl() {
        return '';
    }
}
